import { Injectable } from '@angular/core';
import { Logger } from 'ngx-elvis-ds';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class GUIHelperService {

  private guiType: string = 'memphis';

  isOnline = false;
  config:  { 
    guiType: string,
    pathname: string,
    deviceId: string,
    userId: string 
  };

  constructor(
    // private socket: Socket,
    private configSvc: ConfigService
  ) { }

  async init() {
    // this.socket.on('connect', this.onConnect.bind(this));
    // this.socket.on('connect_error', this.onConnectError.bind(this));
    // this.socket.on('connect_timeout', this.onConnectTimeout.bind(this));
    // this.socket.on('reconnect', this.onReconnect.bind(this));
    // this.socket.on('reconnect_attempt', this.onReconnectAttempt.bind(this));
    // this.socket.on('reconnecting', this.onReconnecting.bind(this));
    // this.socket.on('reconnect_error', this.onReconnectError.bind(this));
    // this.socket.on('reconnect_failed', this.onReconnectFailed.bind(this));
    // this.overrideConsole();
  }

  onWriteLog(level: string, message: string) {
    // if (this.socket) {
    //   this.socket.emit(`write-log`, { level, message })
    // }
  }

  async onLoadConfig() {
    // try {
    //   this.socket.emit(`load-config`, { 
    //     guiType: this.guiType,
    //     pathname: window.location.pathname,
    //   }, (guiConfig) => {
    //     if (guiConfig && !this.configSvc.loaded) {
    //       this.configSvc.set(guiConfig);
    //     }
    //   })
    // } catch (error) {
    //   this.config = undefined;
    // }
  }

  async onLogin(deviceId: string, user: string) {
    // try {
    //   this.config = { 
    //     guiType: this.guiType,
    //     deviceId: deviceId,
    //     pathname: window.location.pathname,
    //     userId: user
    //   };
    //   this.socket.emit(`init-log`, this.config)
    // } catch (error) {
    //   this.config = undefined;
    // }
  }

  async onLogout() {
    // try {
    //   this.config = undefined;
    //   this.socket.emit(`end-log`, this.config)
    // } catch (error) {
    //   this.config = undefined;
    // }
  }

  // private

  async onConnect() { 
    // //Logger.info(`onConnect`);
    // this.isOnline = true;
    // //await this.onLoadConfig();

    // if (this.config) {
    //   this.socket.emit(`init-log`, this.config)
    // }
  }
  
  async onConnectError(err) { 
    //Logger.warn(`onConnectError`);
    this.isOnline = false;
  }
  
  async onConnectTimeout() { 
    //Logger.warn(`onConnectTimeout`);
    this.isOnline = false;
  }

  async onReconnect(attempt: number) {
    //Logger.info(`onReconnect`, attempt);
  }

  async onReconnectAttempt() { 
    //Logger.warn(`onReconnectAttempt`); 
  }
  async onReconnecting(attempt: number) { 
    //Logger.warn(`onReconnecting`, attempt); 
  }
  async onReconnectError(err) { 
    //Logger.warn(`onReconnectError`); 
  }
  async onReconnectFailed() { 
    Logger.warn(`onReconnectFailed`); 
  }

  private async overrideConsole() {
    // if ( window ) {
    //   window.console.log = (...data: any[]) => {
    //     try {
    //       const message = JSON.stringify(data);
    //       if (message !== '[{}]') {
    //         this.onWriteLog('info', message);
    //         console.log(...data);
    //       }
    //     } catch (error) {
    //       console.log(...data);
    //     }
    //   };
    //   window.console.warn = (...data: any[]) => {
    //     try {
    //       const message = JSON.stringify(data);
    //       if (message !== '[{}]') {
    //         this.onWriteLog('warn', message);
    //         console.warn(...data);
    //       }
    //     } catch (error) {
    //       console.warn(...data);
    //     }
    //   };
    //   window.console.error = (...data: any[]) => {
    //     try {
    //       const message = JSON.stringify(data);
    //       if (message !== '[{}]') {
    //         this.onWriteLog('error', message);
    //         console.error(...data);
    //       }
    //     } catch (error) {
    //       console.error(...data);
    //     }
    //   };
    // }
  }
}
